// extracted by mini-css-extract-plugin
export var noSpinners = "_s6-6";
export var percentageInput = "_s6-7";
export var variantColor1 = "_s6-0";
export var variantColor2 = "_s6-1";
export var variantColor3 = "_s6-2";
export var variantColor4 = "_s6-3";
export var variantColor5 = "_s6-4";
export var variantColor6 = "_s6-5";